/* tslint:disable */
/* eslint-disable */
export enum WorkTaskTabColumnEnum {
  DueDate = 'dueDate',
  ProjectCustomer = 'projectCustomer',
  Source = 'source',
  Taskgroup = 'taskgroup',
  InstallationStart = 'installationStart',
  InstallationEnd = 'installationEnd',
  Build = 'build',
  Implementing = 'implementing'
}
